// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"OrderSuccessModal_iconContainer__VJeKZ","successTopIcon":"OrderSuccessModal_successTopIcon__oHomz","title":"OrderSuccessModal_title__y3qOB"};